import AdvancedController from "./advanced-controller";

import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
import { Breakpoints } from "../utils/breakpoints";

const NAV_TOGGLE_BREAKPOINT = "md";

gsap.registerPlugin(Flip);

export default class HorizontalAccordionController extends AdvancedController {
  static targets = ["item"];

  static values = {
    firstOpen: Boolean,
    onlyOneCanBeOpen: Boolean,
    children: { type: Number, default: 0 },
  };

  connect() {
    super.connect(...arguments);

    this.breakpoints = new Breakpoints();

    this.activeItem = null;
    if (this.hasItemTarget) {
      this.itemTarget.classList.add("-active");
      this.activeItem = this.itemTarget;
    }
    this.childrenValue = this.itemTargets.length;
  }

  onToggle({ params: { id } }) {
    const newActive = this.element.querySelector(`#${id}`);
    if (this.activeItem === newActive) {
      return;
    }

    let itemChildTargets = gsap.utils.toArray(newActive.querySelectorAll("*"));

    if (this.activeItem) {
      const oldItemTargets = gsap.utils.toArray(
        this.activeItem.querySelectorAll("*")
      );
      itemChildTargets = itemChildTargets.concat(oldItemTargets);
    }
    const state = Flip.getState(
      this.itemTargets.concat(itemChildTargets).concat(this.element),
      {
        props: "writingMode,fontSize,color,backgroundColor",
      }
    );

    if (this.activeItem && newActive !== this.activeItem) {
      this.activeItem.classList.remove("-active");
    }
    this.activeItem = newActive;

    newActive.classList.add("-active");
    const dur = 0.5;
    Flip.from(state, {
      duration: dur,
      ease: "power1.inOut",
      absolute: false, // make things position: absolute during the flip
      nested: true, // we've got nested flipping elements (more expensive processing)
      scale: false,
      toggleClass: "flipping",
      absoluteOnLeave: false,
      // Fade in or out the elements within the item
      onEnter: (elements) =>
        gsap.fromTo(
          elements,
          { opacity: 0 },
          { opacity: 1, duration: dur / 2, delay: dur / 2 }
        ),
      onLeave: (elements) =>
        gsap.fromTo(
          elements,
          { opacity: (i, el) => state.getProperty(el, "opacity") },
          { opacity: 0, duration: dur / 2 }
        ),
      onComplete: () => {
        if (this.breakpoints.breakpointDown(NAV_TOGGLE_BREAKPOINT)) {
          this.activeItem.scrollIntoView({ behavior: "smooth" });
        }
      },
    });
  }
}
